import { Grid } from "@mui/material";
import MDBox from "components/MDBox";

import { FormTitle, Text, SelectField, SwitchField } from "ui-components/Form";
const zoneTypeOptions = [
  //"External",
  //"Inspection",
  //"InTransit",
  "Quarantine",
  //"Repacking",
  "Return",
  //"Rework",
  "Shipping",
  "Staging",
  "Storage",
  "Variance",
  "Scrap",
];
function ZoneInfo({ whOptions = [], formRender, control, errors, mode = "ADD" }) {
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit Zone Information" : "Zone Information"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { editable, ...data } = property;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(mode === "EDIT" && editable === false && { disabled: true, type: "text" }),
              };
              let renderField;
              switch (fieldProps.type) {
                case "text":
                case "number":
                  renderField = <Text field={fieldProps} />;
                  break;
                case "select":
                  let options = [];
                  switch (data.name) {
                    case "warehouseCode":
                      options = whOptions;
                      break;
                    case "zoneType":
                      options = zoneTypeOptions;
                      break;
                  }
                  renderField = <SelectField field={fieldProps} options={options} />;
                  break;
                case "switch":
                  renderField = <SwitchField field={fieldProps} />;
                  break;
              }

              return (
                <Grid item xs={6} key={index}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default ZoneInfo;
